var _path, _path2, _path3, _path4, _circle, _circle2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSearchResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M0 0H72V72H0z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9D7F4",
    fillRule: "evenodd",
    d: "M53.02 31.47c0 10.844-8.64 19.632-19.296 19.632-10.658 0-19.296-8.788-19.296-19.631S23.066 11.84 33.724 11.84c10.655 0 19.295 8.788 19.295 19.63z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2672E9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M43.818 45.083L59.84 61.106"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EE55CA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27.293 36l9-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.891,
    r: 1.5,
    fill: "#EE55CA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.7,
    cy: 25.891,
    r: 1.5,
    fill: "#EE55CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#2672E9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M51.02 29.47c0 10.844-8.64 19.632-19.296 19.632-10.658 0-19.296-8.788-19.296-19.631S21.066 9.84 31.724 9.84c10.655 0 19.295 8.788 19.295 19.63z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/no-search-results.7c762e3fcc05c691d200b20993414aae.svg";
export { ForwardRef as ReactComponent };